<template>
    <div class="flex align-center">
        <div class="sizeTempWrap">
            <div class="sizeTempText flex align-center" @click="isShow = !isShow">
                <span class="sizeTempName flex-1" v-if="selectTemp">{{selectTemp.sizeMappingName}}</span>
                <span class="sizeTempPlaceholder flex-1" v-else>请选择模版</span>
                <i class="el-icon-arrow-down" :class="{ 'rotate': isShow }"></i>
            </div>
            <transition name="dropdown">
                <div class="sizeTempList" v-show="isShow">
                    <div class="noData" v-if="tempList.length === 0">暂无尺码表模版</div>
                    <div 
                        v-else
                        v-for="(item, index) in tempList" 
                        :key="index" 
                        class="sizeTempItem flex align-center" 
                        :class="{'active': (selectTemp && selectTemp.id) === item.id}"
                        @click="selectItem(item)"
                    >
                        <div class="sizeType">{{sizeGroupMap[item.sizeGroup]}}</div>
                        <div class="sizeName flex-1">{{item.sizeMappingName}}</div>
                        <i class="optBtn el-icon-search" @click.stop="handlePreviewTemp(item)"></i>
                        <i class="optBtn el-icon-Group-42" @click.stop="handleEditTemp(item)"></i>
                        <i class="optBtn el-icon-delete" @click.stop="handleDeleteTemp(item)"></i>
                    </div>                    
                </div>
            </transition>
        </div>
        <el-link :underline="false" class="ml-5" @click="openAddTempDialog">保存为新模版</el-link>
        <el-link :underline="false" class="ml-5" @click="updateSelectedTemplate">更新所选尺码表模版</el-link>
        <el-dialog
            v-if="addTempVisible"
            :title="editTempData ? '更新模版名称' : '保存为新模版'"
            :visible.sync="addTempVisible"
            width="500px"
            :before-close="closeAddTemp"
        >
            <div style="margin-top:20px;">
                <el-input v-model="tempName" placeholder="请输入模版名称20个字符以内" width="300px" :maxlength="20" :show-word-limit="true"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeAddTemp">取 消</el-button>
                <el-button type="primary" @click="saveTemp">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            v-if="viewTempVisible"
            :title="'预览'+viewTempData.sizeMappingName"
            :visible.sync="viewTempVisible"
            width="800px"
        >
            <div>
                <div>【{{sizeGroupMap[viewTempData.sizeGroup]}}】</div>
                <el-table
                    :data="viewSizeTableData"
                    :highlight-current-row="true"
                    :max-height="350"
                    style="width: 100%"
                >
                    <el-table-column width="120px" fixed="left" key="sizeName" prop="sizeName" :label="viewTempData.sizeDetail.name"> </el-table-column>
                    <el-table-column v-for="col in viewTableCols" :key="col.prop" :prop="col.prop" v-bind="col.attrs">
                        <template slot="header">
                            {{ col.label }}
                        </template>
                        <template slot-scope="{ row }">
                            <template v-if="row.isShow">
                                <template v-if="col.isRange">
                                    {{row[col.prop].valueStart}}-{{row[col.prop].valueEnd}}
                                </template>
                                <template v-else>
                                    {{row[col.prop].valueStart}}
                                </template>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewTempVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSizeMappingList,saveSizeMapping,updateSizeMapping,deleteSizeMapping } from '@/servers/prod/center/tb';
import storeMixins from '../store-mixins'
export default {
    mixins: [storeMixins],
    inject:{
        getSpecifications:{default:() => {}},
        sizeGroupObj:{default:{}},
        getOptions:{default:() => {}}
    },
    // model: {
    //     prop: 'value',
    //     event: 'change'
    // },
    props: {
        sizeNameKey: {
            type: String,
            default: '',
        },   
    },
    data() {
        return{
            addTempVisible:false,
            viewTempVisible:false,
            viewTempData:{},
            editTempData:null,
            isShow:false,
            tempName:'',
            tempList:[],
            selectTempId:null,
            sizeGroupMap:{},
            viewSizeTableData:[],
            viewTableCols: [],
        }
    },
    computed:{
        ...mapGetters(['userInfo']),
        selectTemp(){
            if(this.selectTempId){
                return this.tempList.find(item => item.id === this.selectTempId) || null;
            }
            return null
        }
    },
    methods: {
        selectItem(data){
            this.selectTempId = data.id;
            let sizeDetail = data.sizeDetail
            try{
                sizeDetail = JSON.parse(data.sizeDetail)
            }catch(e){
                sizeDetail = {}
            }
            this.$emit('updateSizeMappings',{...data,sizeDetail});
            this.isShow = false;
        },
        handlePreviewTemp(data){
            let sizeDetail = data.sizeDetail
            try{
                sizeDetail = JSON.parse(data.sizeDetail);
                (sizeDetail?.values || []).forEach(item => {
                    item.checked = true
                });
            }catch(e){
                sizeDetail = {}
            }
            let newData = {
                ...data,
                sizeDetail
            }
            this.$emit('getSizeMappingsData',sizeDetail,({colList,tableList})=>{
                this.viewTempVisible = true
                this.viewTempData = newData
                this.viewSizeTableData = tableList
                this.viewTableCols = colList
                this.isShow = false
            });
        },
        handleEditTemp(data){
            this.editTempData = data;
            this.tempName = data.sizeMappingName;
            this.addTempVisible = true
        },
        handleDeleteTemp(data){
            this.$confirm(`是否删除尺码表模版【${data.sizeMappingName}】？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                width: '500px',
            }).then(() => {
                deleteSizeMapping({id:data.id}).then(res => {
                    this.$message.success('删除成功!');
                    this.getTempList()
                });
            }).catch(() => {});
        },
        getTempList(data={}){
            let params = {...data};
            getSizeMappingList(params).then(res => {
                this.tempList = res;
                let sizeGroupOptions = this.getOptions() || [];
                let map = {}
                sizeGroupOptions.forEach(item => {
                    map[item.value] = item.displayName;
                });
                this.sizeGroupMap = map;
            });
        },
        saveTemp(){
            const { companyId } = this.userInfo;
            let sizeProp = this.getSizeProp();
            if(!this.tempName){
                return this.$message.error('请输入模版名称!');
            }
            if(!sizeProp){
                return
            }
            let sizeGroupKey = this.sizeGroupObj.name
            let params = {
                companyId,
                sizeGroup:this.tbForm[sizeGroupKey],
                sizeMappingName:this.tempName,
                sizeDetail:JSON.stringify(sizeProp),
            }
            if(this.editTempData){// 编辑
                params = {
                    ...this.editTempData,
                    sizeMappingName:this.tempName,
                }
                this.updateSizeTemp(params,()=>{
                    this.$message.success('更新成功!');
                    this.getTempList();
                    this.closeAddTemp();
                })
            }else{
                saveSizeMapping(params).then(res => {
                    if(res){
                        this.$message.success('保存成功!');
                        this.getTempList();
                        this.closeAddTemp();
                    }
                })
            }
        },
        // 处理点击外部区域
        handleClickOutside(event) {
            // 检查点击的元素是否在组件内部
            if (!this.$el.contains(event.target)) {
                this.isShow = false;
            }
        },
        openAddTempDialog(){
            this.addTempVisible = true;
        },
        updateSizeTemp(data={},cb){
            if(!data.sizeMappingName){
                return this.$message.error('请输入模版名称!');
            }
            if(!data.sizeDetail){
                return
            }
            updateSizeMapping(data).then(res => {
                if(res){
                    if(cb){
                        cb && cb()
                    }else{
                        this.$message.success('更新成功!');
                        this.getTempList();
                        this.selectTempId = data.id
                    }
                }
            })
        },
        updateSelectedTemplate(){
            if(!this.selectTempId){
                return this.$message.error('未选择尺码表模板!');
            }
            this.$confirm(`确定更新尺码表信息至尺码表模版【${this.selectTemp.sizeMappingName}】？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                width: '500px',
            }).then(() => {
                let sizeDetail = this.getSizeProp();
                let params = {
                    ...this.selectTemp,
                    sizeDetail:JSON.stringify(sizeDetail),
                }
                this.updateSizeTemp(params)
            }).catch(() => {});
        },
        getSizeProp(){
            let [specifications] = this.getSpecifications();
            let sizeProp = specifications.find(item => this.sizeNameKey.includes(item.nameKey));
            if(!sizeProp){
                this.$message.error('请先添加尺码属性!');
                return null
            }
            let values = sizeProp.values.map(item => {
                return {
                    extendValues: item.extendValues,
                    propValueId: item.propValueId,
                    value: item.value,
                    valueKey: item.valueKey,
                }
            });
            let sizeDetail = {
                name:sizeProp.name,
                nameKey:sizeProp.nameKey,
                values
            }
            return sizeDetail
        },
        closeAddTemp(){
            this.addTempVisible = false;
            this.tempName = '';
            this.editTempData = null;
        }
    },
    created() { 
        this.getTempList();
    },
    mounted() {
        // 添加全局点击事件监听
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        // 移除全局点击事件监听
        document.removeEventListener('click', this.handleClickOutside);
    },
}
</script>

<style lang="scss" scoped>
.sizeTempWrap{
    position: relative;
    width: 300px;
    font-size: 12px;
    color: #606266;
    border: 1px solid #DCDFE6;
    .sizeTempText{
        line-height: 28px;
        padding-left: 6px;
        padding-right: 6px;
        cursor: pointer;
        .el-icon-arrow-down {
            transition: transform 0.3s ease;
        }
        .el-icon-arrow-down.rotate {
            transform: rotate(180deg);
        }
    }
    .sizeTempPlaceholder{
        color: #a1a1a1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .sizeTempList{
        position: absolute;
        width: 100%;
        max-height: 300px;
        padding: 5px 0;
        overflow: auto;
        // top: 20px;
        left:-1px;
        background: #fff;
        border: 1px solid #DCDFE6;
        box-sizing: content-box;
        z-index: 9;
        .sizeTempItem{
            padding: 4px 6px;
            cursor: pointer;
            .sizeType{
                color: #fff;
                padding: 0 5px;
                background: #2695FA;
                border-radius: 10px;
            }
            .sizeName{
                // width: 100px;
                margin-left: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .optBtn{
                font-size: 16px;
                margin-left: 5px;
                cursor: pointer;
            }
        }
        .sizeTempItem:hover{
            background: #f5f7fa;
        }
        .sizeTempItem.active{
            // color: #fff;
            background: #c8e0f5;
        }
        .noData{
            text-align: center;
            color: #a6a6a6;
            line-height: 200px;
        }
    }
}

// 下拉框过渡动画
.dropdown-enter-active, .dropdown-leave-active {
    transition: all 0.3s ease;
    transform-origin: top;
}

.dropdown-enter {
    opacity: 0;
    transform: scaleY(0);
}

.dropdown-leave-to {
    opacity: 0;
    transform: scaleY(0);
}

.dropdown-enter-to, .dropdown-leave {
    opacity: 1;
    transform: scaleY(1);
}
</style>